import TableTab2 from "./TableTab2";
const Tab2 = ({ selected_default_item_data,setselected_default_item_data}) => {

  return (
   <div
      className="row mb-3"
      style={{ border: "1px solid #00000059", borderRadius: "5px" }}
    >
      <div className="col-12">
        <p className="boxLabel m-0">Defaults</p>
      </div>
      
      
      
      <TableTab2 setselected_default_item_data={setselected_default_item_data} selected_default_item_data={selected_default_item_data}/>


    </div>
  )
}

export default Tab2